/* eslint-disable @typescript-eslint/no-explicit-any */
import { getErrorMessage } from '@juvare/widget-ui/Utils';
import { WidgetHandler } from '../../WidgetHandler';
export function validateCustom(props, value) {
    var _a, _b;
    let validate;
    if (typeof ((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.custom) === 'function') {
        validate = props.config.validate.custom;
    }
    else if (typeof ((_b = props.config.validate) === null || _b === void 0 ? void 0 : _b.custom) === 'string') {
        const js = props.config.validate.custom;
        try {
            validate = Function('"use strict"; return (function(value, handler) { ' + js + '; })')();
        }
        catch (error) {
            console.error('Invalid custom validation function', error);
            return 'Invalid custom validation function: ' + getErrorMessage(error);
        }
    }
    if (validate) {
        try {
            const result = validate(value, new WidgetHandler(props));
            if (result == null) {
                return undefined;
            }
            else if (typeof result === 'string') {
                return result;
            }
            else {
                console.error('Custom validation function must return string if validation fails or undefined if validation succeeds', result);
                return undefined;
            }
        }
        catch (error) {
            console.error('Custom validation error', error);
            return getErrorMessage(error);
        }
    }
    return undefined;
}
